export default [
    '54 54',
    '<rect x="0.689453" width="53.7516" height="53.7516" rx="100%" fill="var(--light, #000000)"/>\n' +
    '    <path\n' +
    '        d="M25.1075 40.855C18.22 39.6225 13 33.6775 13 26.5C13 18.525 19.525 12 27.5 12C35.475 12 42 18.525 42 26.5C42 33.6775 36.78 39.6225 29.8925 40.855L29.095 40.2025H25.905L25.1075 40.855Z"\n' +
    '        fill="url(#paint0_linear_325_155)"/>\n' +
    '    <path\n' +
    '        d="M33.1548 30.5598L33.8073 26.4998H29.9648V23.6723C29.9648 22.5123 30.3998 21.6423 32.1398 21.6423H34.0248V17.9448C33.0098 17.7998 31.8498 17.6548 30.8348 17.6548C27.4998 17.6548 25.1798 19.6848 25.1798 23.3098V26.4998H21.5548V30.5598H25.1798V40.7823C25.9773 40.9273 26.7748 40.9998 27.5723 40.9998C28.3698 40.9998 29.1673 40.9273 29.9648 40.7823V30.5598H33.1548Z"\n' +
    '        fill="white"/>\n' +
    '    <defs>\n' +
    '      <linearGradient id="paint0_linear_325_155" x1="27.5007" y1="39.9915" x2="27.5007" y2="11.9947"\n' +
    '                      gradientUnits="userSpaceOnUse">\n' +
    '        <stop stop-color="#0062E0"/>\n' +
    '        <stop offset="1" stop-color="#19AFFF"/>\n' +
    '      </linearGradient>\n' +
    '    </defs>'
]